import { NavigateOptions, useLocation, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { setSEOLang } from '@utils/seo';
import { useData } from '@hooks/useData';

export const useCustomNavigate = () => {
    const location = useLocation();
    const { language: currentLanguage } = useParams();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const { allLanguages } = useData();

    // get URL without language
    const getBaseUrl = () => {
        const currentPath = location.pathname;

        if (!currentLanguage) {
            return `${currentPath}${location.search}`;
        }

        const urlSegments = currentPath.split('/');
        return `/${urlSegments.splice(2, urlSegments.length).join('/')}${location.search}`;
    };

    const buildDestinyPath = (baseUrl: string) => {
        return i18n.language === i18n.options?.fallbackLng ? baseUrl : `/${i18n.language}${baseUrl}`;
    };

    return {
        navigate: (url: string, options?: NavigateOptions) => {
            navigate(buildDestinyPath(url), options);
        },
        // changes i18n language and updates url
        changeLanguage: (toLanguage: string) => {
            const baseUrl = getBaseUrl();
            i18n.changeLanguage(toLanguage);
            navigate(buildDestinyPath(baseUrl), { replace: true });
            const locale = allLanguages?.data?.find((item) => item.language_code === toLanguage)?.locale_code || toLanguage;
            setSEOLang(locale);
        },
    };
};
